import React from 'react';
import { LegalLayout } from './LegalLayout';
export const Terms = () => {
  return <LegalLayout title="Términos y Condiciones" data-id="element-415">
      <section className="mb-8" data-id="element-416">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-417">
          1. Naturaleza del producto
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-418">
          "Efectivo Inmediato en 48 Horas" es un producto digital con valor de{' '}
          <span className="text-[#ADFF2F] font-semibold" data-id="element-419">6.39 dólares</span>,
          entregado en formato PDF descargable. Al realizar la compra, el
          usuario acepta estos términos en su totalidad.
        </p>
      </section>

      <section className="mb-8" data-id="element-420">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-421">
          2. Acceso digital inmediato
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-422">
          El acceso al PDF se otorga de forma inmediata tras la confirmación del
          pago. El usuario podrá descargarlo desde cualquier dispositivo con
          conexión a internet. No se envían copias físicas.
        </p>
      </section>

      <section className="mb-8" data-id="element-423">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-424">
          3. Política de reembolsos
        </h2>
        <p className="text-gray-300 leading-relaxed mb-3 font-sans" data-id="element-425">
          Ofrecemos garantía de devolución bajo las siguientes condiciones:
        </p>
        <ul className="space-y-2 text-gray-300 leading-relaxed font-sans list-disc pl-6" data-id="element-426">
          <li data-id="element-427">
            Las solicitudes de reembolso{' '}
            <span className="text-white font-semibold" data-id="element-428">
              deben realizarse dentro de las primeras 24 horas
            </span>{' '}
            posteriores a la compra.
          </li>
          <li data-id="element-429">
            Pasado este plazo, no se procesarán devoluciones bajo ninguna
            circunstancia, debido a la naturaleza digital del producto.
          </li>
          <li data-id="element-430">
            Para solicitar un reembolso, escribir a{' '}
            <a href="mailto:edison_link@hotmail.com" className="text-[#ADFF2F] hover:underline" data-id="element-431">
              edison_link@hotmail.com
            </a>
            .
          </li>
        </ul>
      </section>

      <section className="mb-8" data-id="element-432">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-433">
          4. Resultados no garantizados
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-434">
          Este es un producto educativo. Los resultados, ingresos o ganancias
          mencionados en la página de ventas son ejemplos de resultados que han
          obtenido otros usuarios. No representan una garantía de ingresos para
          el comprador.{' '}
          <span className="text-white" data-id="element-435">
            El rendimiento depende exclusivamente del esfuerzo, dedicación y
            capacidad de aplicación de cada persona.
          </span>
        </p>
      </section>

      <section className="mb-8" data-id="element-436">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-437">
          5. Uso del contenido
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-438">
          El contenido del PDF es de uso personal. Está prohibida la
          redistribución, reventa o copia parcial o total del material sin
          autorización expresa por escrito.
        </p>
      </section>

      <section data-id="element-439">
        <h2 className="text-2xl font-bold text-white mb-3 font-sans" data-id="element-440">
          6. Contacto
        </h2>
        <p className="text-gray-300 leading-relaxed font-sans" data-id="element-441">
          Cualquier consulta sobre estos términos puede dirigirse a{' '}
          <a href="mailto:edison_link@hotmail.com" className="text-[#ADFF2F] hover:underline" data-id="element-442">
            edison_link@hotmail.com
          </a>
          .
        </p>
      </section>
    </LegalLayout>;
};